import { useCallback, useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/shared/ui'
import { request } from '@/utils/http/client'
import type { ApiEnvelope } from '@/shared/api/repositories/http-repositories'
import { saveAuthReturnPath } from '@/shared/lib/auth-redirect'
import { ProductFooter } from '@/shared/ui/product-shell/ProductFooter'

import '@/shared/ui/product-shell/legacy-product.css'

interface LoginLocationState {
  from?: string
  packId?: string
}

export function UserLoginPage() {
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)
  const location = useLocation()
  const autoStarted = useRef(false)
  const locationState = location.state as LoginLocationState | null
  const from = locationState?.from
  const packId = locationState?.packId

  const handleCasdoorLogin = useCallback(async () => {
    setLoading(true)
    setError('')
    try {
      const returnPath = packId ? `/checkout?packageId=${encodeURIComponent(packId)}` : from
      saveAuthReturnPath(returnPath)
      const response = await request<ApiEnvelope<{ url: string }>>({
        method: 'GET',
        url: '/auth/casdoor/authorize',
        skipAuth: true,
        skipRefresh: true,
      })
      if (!response.data?.url) throw new Error('登录地址获取失败，请稍后重试')
      window.location.replace(response.data.url)
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : '登录服务暂不可用')
      setLoading(false)
    }
  }, [from, packId])

  useEffect(() => {
    if (autoStarted.current) return
    autoStarted.current = true
    void handleCasdoorLogin()
  }, [handleCasdoorLogin])

  if (loading && !error) return null

  return (
    <div className="legacy-product-page legacy-auth-page">
      <main className="grid min-h-screen place-items-center p-4">
        <Card className="w-full max-w-md">
          <CardHeader>
            <Link to="/" className="mb-3 text-sm text-primary">
              ← 返回首页
            </Link>
            <CardTitle>登录</CardTitle>
            <CardDescription>
              使用 Casdoor 账号登录，新用户将自动注册
            </CardDescription>
          </CardHeader>
          <CardContent>
            {error && (
              <p role="alert" className="mb-4 text-sm text-destructive">
                {error}
              </p>
            )}
            {error ? (
              <Button onClick={() => void handleCasdoorLogin()} disabled={loading} className="w-full">
                重试 Casdoor 登录
              </Button>
            ) : (
              <p className="text-center text-sm text-muted-foreground">正在跳转到 Casdoor 登录页…</p>
            )}
          </CardContent>
        </Card>
      </main>
      <ProductFooter />
    </div>
  )
}
